import { combineReducers } from "redux";

import user from "./user";
import settings from "./settings";
import planer from "./planer";
import fs from "./fs";
import tasklist from "./tasklist";
import { USER_LOGGED_OUT } from "../actions/types";

/**
 * Combines all reducers into a root reducer.
 */
const appReducer = combineReducers({
  user,
  settings,
  planer,
  fs,
  tasklist
});

const rootReducer = (state, action) => {
  let updatedState = state;

  switch (action.type) {
    case USER_LOGGED_OUT:
      updatedState = undefined;
      break;
    default:
      break;
  }

  return appReducer(updatedState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js